<template>
	<pui-modal-dialog
		:titleText="titleText"
		:messageText="messageText"
		:okText="okText"
		:cancelText="cancelText"
		:widthDialog="widthDialog"
		:dialogName="dialogName"
		ref="modalForm"
	>
		<template slot="message">
			<component :is="componentName" :pk="componentPk" :method="componentMethod" isModalDialog></component>
		</template>
	</pui-modal-dialog>
</template>

<script>
export default {
	name: 'PuiSelectDetailDialog',
	props: {
		parentId: {
			type: String,
			required: true
		},
		componentLabel: {
			type: String,
			required: true
		},
		componentName: {
			type: String,
			required: true
		},
		componentPk: {
			type: String,
			required: true
		},
		componentMethod: {
			type: String,
			required: true
		},
		modelName: {
			type: String,
			default: null,
			required: false
		}
	},
	data() {
		return {
			titleText: this.componentLabel,
			messageText: '',
			okText: this.componentMethod !== 'read' ? this.$t('form.save') : this.$t('form.ok'),
			cancelText: this.componentMethod !== 'read' ? this.$t('form.cancel') : null,
			widthDialog: window.innerWidth * 0.9,
			dialogName: this.componentName + '_' + this.parentId + '_popup'
		};
	},
	mounted() {
		var self = this;
		this.$puiEvents.$on(`pui-modalDialog-${this.dialogName}-ok`, () => {
			if (self.componentMethod === 'read') {
				this.$puiEvents.$emit(`pui-modalDialog-${self.dialogName}-hide`);
			} else {
				const form = self.getFormComponent(self.$refs.modalForm.$children[0]);
				if (form) {
					form.save(true);
					this.$puiEvents.$on(`onPui-insertRow-dataTable-${self.modelName}`, (data) => {
						this.$puiEvents.$emit(`pui-modalDialog-${self.dialogName}-hide`, data);
					});
					this.$puiEvents.$on(`onPui-editRow-dataTable-${self.modelName}`, (data) => {
						this.$puiEvents.$emit(`pui-modalDialog-${self.dialogName}-hide`, data);
					});
				} else {
					this.$puiEvents.$emit(`pui-modalDialog-${self.dialogName}-hide`);
				}
			}
		});
		this.$puiEvents.$on(`pui-modalDialog-${this.dialogName}-cancel`, () => {
			this.$puiEvents.$emit(`pui-modalDialog-${self.dialogName}-hide`);
		});
	},
	destroyed() {
		this.$puiEvents.$off(`pui-modalDialog-${this.dialogName}-ok`);
		this.$puiEvents.$off(`pui-modalDialog-${this.dialogName}-cancel`);
		if (this.modelName) {
			this.$puiEvents.$off(`onPui-insertRow-dataTable-${this.modelName}`);
			this.$puiEvents.$off(`onPui-editRow-dataTable-${this.modelName}`);
		}
	},
	methods: {
		getFormComponent(component) {
			if (!component) {
				return null;
			}
			if (
				component.$options &&
				(component.$options._componentTag === `${this.modelName}form` || component.$options._componentTag === `${this.modelName}-form`)
			) {
				return component;
			}
			for (let i = 0, childrenLength = component.$children.length; i < childrenLength; i++) {
				const child = this.getFormComponent(component.$children[i]);
				if (
					child &&
					child.$options &&
					(child.$options._componentTag === `${this.modelName}form` || child.$options._componentTag === `${this.modelName}-form`)
				) {
					return child;
				}
			}
		}
	}
};
</script>
